import { UserSessionContext } from 'components/UserSession';
import { useContext, useState, useEffect } from 'react';
import { useSelector } from 'react-redux';
import { selectWebinarById } from 'models/webinars';
import findAvailableLocale from 'models/helpers/findAvailableLocale';
import useInterval from './useInterval';

const useJoinWebinarTracking = (webinarId: string) => {
  const userSession = useContext(UserSessionContext).userSession || {};
  const webinar = useSelector((s) => selectWebinarById(s, webinarId));

  const [count, setCount] = useState(0);
  const perSeconds = 60;

  useEffect(() => {
    // stop the existing interval (clear current duration)
    // to avoid sending event for new webinar after 10s when the current interval timer is already 50s
    setCount(0);
    // restart a new interval
    setCount(1);
  // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [webinarId]);

  useInterval(() => {
    if (!userSession) return;

    const stayTime = count * perSeconds;
    window.trackingItemToFirebase(
      userSession, 'Webinar', 'Session_DetailPage_Stay',
      'Stay', stayTime, webinar.id, findAvailableLocale(webinar.translations || {}, 'en')?.title,
    );
    setCount((prev) => prev + 1);
  }, count ? 1000 * perSeconds : null);

  return null;
};

export default useJoinWebinarTracking;
